import getField from '@form/formGenerator'

export const seasonSaveUrl = `${import.meta.env.VITE_API_URL}/api/mission-seasons`

export const seasonFormObject = {
  id: null,
  startsAt: null,
  endsAt: null,
  name: '',
  isActive: '',
  firstScanStartsAt: "",
  firstScanEndsAt: "",
  firstScanPilots: "",
  secondScanStartsAt: "",
  secondScanEndsAt: "",
  secondScanPilots: ""
}

export const seasonFormFields = (step, seasonFormObject, updateFormObject, updateFormObjectProp, saveForm, data, creationModalCaller, errors, isLoading, t) => {
  let fields = []
  fields['season'] = [
    {
      type: 'text',
      name: 'name',
      label: t('season:form.name'),
      value: seasonFormObject.name,
      key: 'seasonFormObject-name',
      cssClass: 'column is-6'
    }, {
      type: 'switcher',
      name: 'isActive',
      label: t('season:form.is_active'),
      value: seasonFormObject.isActive,
      cssClass: 'column is-6',
      key: 'seasonFormObject-isActive',
      id: 'missionSeasonIsActive'
    },
    {
      type: 'date',
      name: 'startsAt',
      value: seasonFormObject.startsAt,
      label: t('season:form.from'),
      key: 'seasonFormObject-startsAt',
      cssClass: 'mission-starts-at column',
      isInline: true,
      isRequired: true
    }, {
      type: 'date',
      name: 'endsAt',
      value: seasonFormObject.endsAt,
      label: t('season:form.to'),
      key: 'seasonFormObject-endsAt',
      cssClass: 'mission-ends-at column',
      isInline: true,
      isRequired: true
    }
  ]

  fields['firstScan'] = [
    {
      type: 'date',
      name: 'firstScanStartsAt',
      value: seasonFormObject.firstScanStartsAt,
      label: t('season:form.from'),
      key: 'seasonFormObject-firstScanStartsAt',
      cssClass: 'mission-starts-at column',
      isInline: true,
      isRequired: true
    }, {
      type: 'date',
      name: 'firstScanEndsAt',
      value: seasonFormObject.firstScanEndsAt,
      label: t('season:form.to'),
      key: 'seasonFormObject-firstScanEndsAt',
      cssClass: 'mission-ends-at column',
      isInline: true,
      isRequired: true
    },
    {
      type: 'checkbox',
      name: 'firstScanPilots',
      label: t('season:form.which_pilot'),
      key: 'seasonFormObject-firstScanPilots',
      cssClass: 'column',
      options: data.pilots,
      canCreate: true,
      creationModalCaller: () => creationModalCaller('userRegister', 'pilots'),
      isMultiple: true,
      value: seasonFormObject.firstScanPilots,
      isRequired: true
    }]

  fields['secondScan'] = [{
    type: 'date',
    name: 'secondScanStartsAt',
    value: seasonFormObject.secondScanStartsAt,
    label: t('season:form.from'),
    key: 'seasonFormObject-secondScanStartsAt',
    cssClass: 'mission-starts-at column',
    isInline: true,
    isRequired: true
  }, {
    type: 'date',
    name: 'secondScanEndsAt',
    value: seasonFormObject.secondScanEndsAt,
    label: t('season:form.to'),
    key: 'seasonFormObject-secondScanEndsAt',
    cssClass: 'mission-ends-at column',
    isInline: true,
    isRequired: true
  },
  {
    type: 'checkbox',
    name: 'secondScanPilots',
    label: t('season:form.which_pilot'),
    key: 'seasonFormObject-secondScanPilots',
    cssClass: 'column',
    options: data.pilots,
    canCreate: true,
    creationModalCaller: () => creationModalCaller('userRegister', 'pilots'),
    isMultiple: true,
    value: seasonFormObject.secondScanPilots,
    isRequired: true
  }]

  fields['submit'] = [
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('season:form.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'seasonFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(seasonFormObject.id),
      key: 'seasonFormObject-id'
    }
  ]

  return fields[step].map(function (field) {
    return getField({
      ...field,
      error: errors[field.name] ? errors[field.name].errors : ''
    }, updateFormObject, updateFormObjectProp)
  })
}

export default seasonFormFields
